export default function Validate(value, checkType) {
  const error = [];
  checkType.map((item, i) => {
    const errorReturn = CheckValidationError(value, item);
    if (errorReturn !== "") {
      if (errorReturn[0] === " ") {
        error.push({ errorMsg: "spaceNotallowed" });
      } else {
        error.push({
          character: [...errorReturn],
          errorMsg: "characterNotallowed",
        });
      }
    }
  });
  return error;
}

function CheckValidationError(value, checkType) {
  switch (checkType) {
    case "Special_Char":
      const specialCharacterRegex = /[!@#$%^&*(),.?":{}|<>\s_-]/g;
      const iscontain = value.match(specialCharacterRegex);

      return iscontain === null ? "" : iscontain.length > 0 ? iscontain : "";
  }
}
